import React, { useState } from "react";
import "./style.css";

const AccountToggle = ({ onToggle }) => {
  const [isOn, setIsOn] = useState(true);
  const toggleId = `account-toggle-${Date.now()}`;

  const handleToggle = () => {
    const newIsOn = !isOn;
    setIsOn(newIsOn);
    onToggle(newIsOn);
  };

  return (
    <div className="tw-inline-flex tw-items-center">
      <input
        checked={isOn}
        onChange={handleToggle}
        className="account-toggle-checkbox"
        id={toggleId}
        type="checkbox"
      />
      <label
        className="account-toggle-label"
        style={{ background: isOn ? "#f88f0f" : "grey" }}
        htmlFor={toggleId}>
        <span className="account-toggle-button" />
      </label>
    </div>
  );
};

export default AccountToggle;
